import { readonly, ref } from 'vue';

const isOpen = ref(false);
const isDestructive = ref(false);
const customMessage = ref('');
const customHeader = ref('');
const customAcceptLabel = ref('');
const objectName = ref('');
const base_z_index = ref(0);
let resolvePromise = null;

export default function useGlobalConfirm() {
  /**
   * @param {{ destructive?: boolean; message?: string; header?: string; object_name?: string; accept_label?: string }} options
   * @returns {Promise<boolean>}
   */
  const confirm = (
    options = {
      destructive: false,
      message: '',
      header: '',
      object_name: '',
      accept_label: '',
      base_z_index: 0,
    },
  ) => {
    base_z_index.value = options.base_z_index ?? 0;
    isOpen.value = true;
    isDestructive.value = options.destructive ?? false;
    customMessage.value = options.message ?? '';
    customHeader.value = options.header ?? '';
    objectName.value = options.object_name ?? '';
    customAcceptLabel.value = options.accept_label ?? '';
    return new Promise((resolve) => {
      resolvePromise = resolve;
    });
  };

  const handleConfirm = () => {
    isOpen.value = false;
    if (resolvePromise) {
      resolvePromise(true);
      resolvePromise = null;
    }
  };

  const handleCancel = () => {
    isOpen.value = false;
    if (resolvePromise) {
      resolvePromise(false);
      resolvePromise = null;
    }
  };

  return {
    isOpen: readonly(isOpen),
    isDestructive: readonly(isDestructive),
    customMessage: readonly(customMessage),
    customHeader: readonly(customHeader),
    customAcceptLabel: readonly(customAcceptLabel),
    objectName: readonly(objectName),
    base_z_index: readonly(base_z_index),
    confirm,
    handleConfirm,
    handleCancel,
  };
}
